import { render, staticRenderFns } from "./SummaryBox.vue?vue&type=template&id=4b7dd809&scoped=true&"
import script from "./SummaryBox.vue?vue&type=script&lang=js&"
export * from "./SummaryBox.vue?vue&type=script&lang=js&"
import style0 from "./SummaryBox.vue?vue&type=style&index=0&id=4b7dd809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7dd809",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
